/* DATA INDICATORS */
export const POLICIES_DATA = "POLICIES_DATA"
export const REMOVE_POLICY_EVENT = "REMOVE_POLICY_EVENT"
export const ADD_POLICY_EVENT = "ADD_POLICY_EVENT"
